module.exports = __webpack_public_path__ + "img/TC.c893036a.svg";